import { lazy, Suspense } from 'react';

import { Greeting } from '../greeting';

const SelfPacedGameCoreLoader = lazy(
  () => import('./self-paced-game-core-loader')
);

export const SelfPacedGameCoreLoaderLazy = () => {
  return (
    <Suspense fallback={<Greeting />}>
      <SelfPacedGameCoreLoader />
    </Suspense>
  );
};
